import classnames from 'classnames'
import React from 'react'
import { Classes, Tag } from '@blueprintjs/core'
import { ColorSquare, HighlightedText } from '@ui'
import Catalog, { CatalogProps, ItemProps } from '@ui/GenericCatalog'
import api, { IDepartment } from '@api'

export default function DepartmentCatalog(props: CatalogProps<IDepartment>) {
  return <Catalog<IDepartment> list={api.department.search} Item={DepartmentItem} {...props} />
}

export function DepartmentItem({ skeleton, data, query, refItem }: ItemProps<IDepartment>) {
  if (skeleton) {
    return (
      <div className="flex flow-grow items-center py-1">
        <ColorSquare skeleton />
        <div className="ml-2">
          <span className={Classes.SKELETON}>Department name</span>
        </div>
      </div>
    )
  }

  const { color, name, parentDepartment } = data as IDepartment

  return (
    <div
      ref={refItem as React.Ref<HTMLDivElement>}
      className={classnames('flex-grow truncate', {
        'py-1': !parentDepartment,
      })}
    >
      <div className="flex justify-between">
        <div className="flex items-center truncate">
          <ColorSquare style={{ background: `#${color}` }} />
          <div className="ml-2 font-medium truncate">
            <HighlightedText query={query} text={name} />
          </div>
        </div>
        {parentDepartment && (
          <Tag minimal round className="flex-shrink-0">
            Team
          </Tag>
        )}
      </div>
      {parentDepartment && (
        <div className="flex items-center text-xs text-grey-600">
          <div className="ml-6 flex-grow truncate">{parentDepartment.name}</div>
        </div>
      )}
    </div>
  )
}
